export default "__VITE_ASSET__3HuOr4uA__"